(function() {
    'use strict';

    angular
        .module('wamasysApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('organisation', {
            parent: 'entity',
            url: '/organisation?page&sort&search',
            data: {
                authorities: ['ROLE_SUPER_ADMIN'],
                pageTitle: 'wamasysApp.organisation.home.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/business/organisation/organisations.html',
                    controller: 'OrganisationController',
                    controllerAs: 'vm'
                }
            },
            params: {
                page: {
                    value: '1',
                    squash: true
                },
                sort: {
                    value: 'id,asc',
                    squash: true
                },
                search: null
            },
            resolve: {
                pagingParams: ['$stateParams', 'PaginationUtil', function ($stateParams, PaginationUtil) {
                    return {
                        page: PaginationUtil.parsePage($stateParams.page),
                        sort: $stateParams.sort,
                        predicate: PaginationUtil.parsePredicate($stateParams.sort),
                        ascending: PaginationUtil.parseAscending($stateParams.sort),
                        search: $stateParams.search
                    };
                }],
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('organisation');
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]
            }
        })
        .state('organisation-detail', {
            parent: 'entity',
            url: '/organisation/{id}',
            data: {
                authorities: ['ROLE_SUPER_ADMIN'],
                pageTitle: 'wamasysApp.organisation.detail.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/business/organisation/organisation-detail.html',
                    controller: 'OrganisationDetailController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('organisation');
                    return $translate.refresh();
                }],
                entity: ['$stateParams', 'Organisation', function($stateParams, Organisation) {
                    return Organisation.get({id : $stateParams.id});
                }]
            }
        })
        .state('organisation.new', {
            parent: 'organisation',
            url: '/new',
            data: {
                authorities: ['ROLE_SUPER_ADMIN']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/business/organisation/organisation-dialog.html',
                    controller: 'OrganisationDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: function () {
                            return {
                                name: null,
                                description: null,
                                address: null,
                                country: null,
                                activated: true,
                                id: null
                            };
                        }
                    }
                }).result.then(function() {
                    $state.go('organisation', null, { reload: true });
                }, function() {
                    $state.go('organisation');
                });
            }]
        })
        .state('organisation.edit', {
            parent: 'organisation',
            url: '/{id}/edit',
            data: {
                authorities: ['ROLE_SUPER_ADMIN']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/business/organisation/organisation-dialog.html',
                    controller: 'OrganisationDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['Organisation', function(Organisation) {
                            return Organisation.get({id : $stateParams.id});
                        }]
                    }
                }).result.then(function() {
                    $state.go('organisation', null, { reload: true });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('organisation.delete', {
            parent: 'organisation',
            url: '/{id}/delete',
            data: {
                authorities: ['ROLE_SUPER_ADMIN']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/business/organisation/organisation-delete-dialog.html',
                    controller: 'OrganisationDeleteController',
                    controllerAs: 'vm',
                    size: 'md',
                    resolve: {
                        entity: ['Organisation', function(Organisation) {
                            return Organisation.get({id : $stateParams.id});
                        }]
                    }
                }).result.then(function() {
                    $state.go('organisation', null, { reload: true });
                }, function() {
                    $state.go('^');
                });
            }]
        });
    }

})();
